export default __webpack_public_path__ + "static/mea-shortlist-db76421f183ebe926d127063b96412b4.png";